// extracted by mini-css-extract-plugin
module.exports = {"globalBadgeContent":"SocialAvatar_globalBadgeContent__i5JaH","globalBadge":"SocialAvatar_globalBadge__fE7CG"};